module.exports = __webpack_public_path__ + "static/media/instagram.b17caf00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/instagram.svg
// module id = 244
// module chunks = 0